export default "__VITE_ASSET__DyfZboH2__"